type LoadGoogleMapsCallback = (loaded: boolean) => void;

export const loadGoogleMapsScript = (callback: LoadGoogleMapsCallback) => {
  if (typeof window === "undefined") {
    callback(false);
    return;
  }

  // Check if Google Maps (Places) is already loaded
  if (window.google?.maps?.places) {
    callback(true);
    return;
  }

  const apiKey = process.env.PUBLIC_REMIX_GOOGLE_MAP || import.meta.env.PUBLIC_REMIX_GOOGLE_MAP;

  if (!apiKey) {
    console.error("Google Maps API key not found. Please set PUBLIC_REMIX_GOOGLE_MAP environment variable.");
    callback(false);
    return;
  }

  // Check if script is already being loaded
  const existingScript = document.querySelector('script[src*="maps.googleapis.com"]');
  if (existingScript) {
    existingScript.addEventListener('load', () => callback(!!window.google?.maps?.places));
    return;
  }

  console.log("Loading Google Maps script");
  const script = document.createElement("script");
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
  script.async = true;
  script.defer = true;
  script.onload = () => callback(!!window.google?.maps?.places);
  script.onerror = () => {
    console.error("Failed to load Google Maps API");
    callback(false);
  };
  document.body.appendChild(script);
};
